module.exports = __webpack_public_path__ + "media/images/logos/creditreform_logo-399a24e81033a5f83fae20c53e3a524c.svg";